// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"60ad339c","553":"a2d5ccdf","952":"91a44f84","977":"0d4926c6"}[chunkId] + ".chunk.js";
};